import * as S from "./styles";
import { TextoSubtituloModal } from "../Contrato/Ativo/styles";
import { useEffect, useRef, useState } from "react";
import podeFecharAoClicarFora from "../../utils/fecharAoClicarFora";

export function GerarModalConfirmacao({
  titulo,
  subTitulo,
  observacao,
  trigger,
  botaoCancelar,
  botaoConfirmar,
  ativo = false,
  onFechar = () => {},
  campoInput,
  style,
  disabled,
}) {
  const keyDownRef = useRef(null);

  const [aberto, setAberto] = useState(false);

  useEffect(() => {
    setAberto(ativo);
  }, [ativo]);

  useEffect(() => {
    function teclaPressionada(e) {
      if (e.key === "Enter") {
        setAberto(true);
      }
    }

    if (keyDownRef.current) {
      keyDownRef.current.addEventListener("keydown", teclaPressionada);
    }

    return () => {
      if (keyDownRef.current) {
        keyDownRef.current.removeEventListener("keydown", teclaPressionada);
      }
    };
  }, [keyDownRef]);

  return (
    <div tabIndex={0} ref={keyDownRef}>
      <S.PopupCustomizadoMin
        trigger={trigger}
        modal
        nested
        disabled={disabled}
        open={ativo || aberto ? ativo || aberto : null}
        closeOnDocumentClick={podeFecharAoClicarFora()}
        onClose={() => {
          if (podeFecharAoClicarFora()) {
            setAberto(false);
            onFechar();
          }
        }}
      >
        {(close) => (
          <S.ContainerPopup style={style}>
            <S.CabecalhoModalCancelarRecorrencia>
              <S.TextoCabecalhoModalCancelarRecorrencia>
                {titulo}
              </S.TextoCabecalhoModalCancelarRecorrencia>
            </S.CabecalhoModalCancelarRecorrencia>

            <TextoSubtituloModal>{subTitulo}</TextoSubtituloModal>

            <div>{campoInput}</div>

            <p>
              <b>{observacao}</b>
            </p>

            <S.FooterModal>
              {botaoCancelar(close)}
              {botaoConfirmar(close)}
            </S.FooterModal>
          </S.ContainerPopup>
        )}
      </S.PopupCustomizadoMin>
    </div>
  );
}
